const settings = {
  APP_URL: process.env.VUE_APP_URL,
  APP_BASE: process.env.VUE_APP_BASE,
};

export default settings;
